import {FC} from 'react';
import {SelectedBank} from '../../model';
import {StepLayout} from 'features/registration';
import {BankListPanel} from '../components/BankListPanel/BankListPanel';
import styles from './PaymentBankSelectStep.module.css';

type Props = {
	selectedBank: SelectedBank | null;
	onSelect: (bank: SelectedBank) => void;
};

export const PaymentBankSelectStep: FC<Props> = ({selectedBank, onSelect}) => {
	return (
		<StepLayout variant="fill" className={styles.root}>
			<StepLayout.Title>Выберите банк</StepLayout.Title>

			<StepLayout.Content className={styles.content}>
				<BankListPanel
					sbpBanksOnly
					selectedBankId={selectedBank?.id ?? null}
					onSelect={onSelect}
				/>
			</StepLayout.Content>
		</StepLayout>
	);
};
